<app-loader></app-loader>
<ng-container *ngIf="selectedSchoolId">
  <span class="overline">School</span>
  <h3 class="mt-2">General Information</h3>
</ng-container>
<!-- NONE EDIT MODE no Form -->
<div class="row m-2 py-4" *ngIf="!editModeOff">
  <div class="col">
    <div class="data-list-item my-2">
      <div>School Name</div>
      <div>
        <strong class="right-align">
          {{ schoolData?.schoolName }}
        </strong>
      </div>
    </div>
    <app-divider></app-divider>
    <div class="data-list-item my-2">
      <div>
        School Type
      </div>
      <div>
        <strong class="right-align">{{ schoolData?.schoolType }}</strong>
      </div>
    </div>
    <app-divider></app-divider>
    <div class="data-list-item my-2">
      <div>
        School School Code
      </div>
      <div>
        <strong class="right-align">{{ schoolData?.schoolCode }}</strong>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="data-list-item my-2">
      <div>
        OPE ID
      </div>
      <div>
        <strong class="right-align">
          <span>{{ schoolData?.opeId }}</span>
        </strong>
      </div>
    </div>
    <app-divider class="margin-bottom-16"></app-divider>
    <span class="mb-4 overline">Title IV Eligible</span>
    <app-divider></app-divider>
    <div class="data-list-item my-2">
      <div>
        Eligible
      </div>
      <div>
        <strong class="right-align">
          {{ schoolData?.titleivEligibility.eligible | flag }}
        </strong>
      </div>
    </div>
    <app-divider></app-divider>
    <div class="data-list-item my-2">
      <div>Effective Date</div>
      <div>
        <strong class="right-align">
          {{ schoolData?.titleivEligibility.effectiveDate | date: 'MM/dd/yyyy' }}
        </strong>
      </div>
    </div>
  </div>
</div>
<app-divider></app-divider>
<!-- EDIT MODE shows Form -->
<form *ngIf="editModeOff" [formGroup]="form">
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>School Name</mat-label>
        <input matInput type="text" placeholder="School Name" formControlName="schoolName" />
      </mat-form-field>
      <!-- school type -->
      <mat-form-field>
        <mat-label>School Type</mat-label>
        <input
          matInput
          type="text"
          placeholder="School Type"
          formControlName="schoolType"
          [errorStateMatcher]="matcher"
        />
        <mat-error *ngIf="form.controls['schoolType'].errors?.minlength">
          Please enter a school number with at least 5 digits.
        </mat-error>
        <mat-error *ngIf="form.controls['schoolType'].errors?.maxlength">
          Please enter a school number that has NO more than 15 digits.
        </mat-error>
      </mat-form-field>
      <!-- school code -->
      <mat-form-field>
        <mat-label>School Code</mat-label>
        <input
          matInput
          type="text"
          placeholder="School Code"
          formControlName="schoolCode"
          [errorStateMatcher]="matcher"
        />
        <mat-error *ngIf="form.controls['schoolCode'].errors?.minlength">
          Please enter a school number with at least 5 digits.
        </mat-error>
        <mat-error *ngIf="form.controls['schoolCode'].errors?.maxlength">
          Please enter a school number that has NO more than 15 digits.
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field class="margin-bottom">
        <mat-label>OPE ID</mat-label>
        <input matInput type="text" placeholder="OPE ID" formControlName="opeid" />
      </mat-form-field>
      <app-divider class="margin-bottom-16"></app-divider>
      <span class="mb-4 overline">Title IV Eligible</span>
      <app-divider></app-divider>
      <mat-form-field class="margin-bottom">
        <mat-label>Eligible</mat-label>
        <mat-select data-cy="schoolIsEligibleSelect" placeholder="eligible" formControlName="eligible">
          <mat-option *ngFor="let bool of eligible" [value]="bool">
            {{ bool.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="margin-bottom">
        <mat-label>Effective Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="effectiveDate" placeholder="Effective Date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</form>
<div class="row pad-bot-10" *ngIf="selectedSchoolId">
  <div class="col d-flex justify-content-start">
    <button
      mat-stroked-button
      color="accent"
      data-cy="school-demographics-edit-button"
      (click)="editForm()"
      *ngIf="!editModeOff"
      [disabled]="wrongUser"
    >
      Edit
    </button>
    <button mat-raised-button color="primary" (click)="cancelEdit()" *ngIf="editModeOff" class="margin-right-10">
      Cancel Edit
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      *ngIf="editModeOff"
      [disabled]="form.pristine || form.invalid"
      class="margin-right-10"
      (click)="submit()"
    >
      Save Changes
    </button>
    <button mat-stroked-button color="accent" *ngIf="editModeOff" [disabled]="form.pristine" (click)="revertForm()">
      Revert Changes
    </button>
  </div>
  <div class="col"></div>
</div>
